import React from 'react';

import CoproValidation from '../../components/Admin/CoproValidation';

function CoproValidationView() {
  return (
    <CoproValidation />
  );
}

export default CoproValidationView;
